export class StockExcelUploadReq{
    formData : any
    createdUser : string
    constructor(formData:any,createdUser:string){
        this.formData = formData
        this.createdUser = createdUser
    }
}